import React, { useState, useEffect, useRef } from "react";
import styled, { css } from "styled-components";
import breakpoints from "Helpers/BreakpointHelper";
import media from "styled-media-query";
import { FlexContainer } from "BaseComponents/Flex/FlexContainer";
import { Input } from "BaseComponents/Form";
import { SubmitButton } from "BaseComponents/Button";

export const LoginColumn = styled(FlexContainer)`
	height: 100vh;
`;
export const LoginLeftColumn = styled(LoginColumn)`
	background-image: ${({ bgImage }) =>
		`linear-gradient(rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0.9)), url(${bgImage})`};
	background-repeat: no-repeat;
	background-size: cover;
	background-position: center;
	display: flex;
	align-items: flex-start;
	flex-direction: column;
	padding: 2rem 10px;

	${media.greaterThan(breakpoints.mobile)`	
        padding: 2rem;
        flex-basis: 50%;
        background-image: none;
        max-width: 441px;
        background-color: #f6f6f6;
  	`};
`;

export const LoginRightColumn = styled(LoginColumn)`
	flex-basis: 0;
	${media.greaterThan(breakpoints.mobile)`	
        background-image: ${({ bgImage }) =>
			`linear-gradient(rgba(246, 148, 39, 0.7), rgba(246, 148, 39, 0.7)), url(${bgImage})`};
        background-repeat: no-repeat;
        background-size: cover;
        background-position: center;
        flex-basis: 70%;
  	`};
`;
export const LogoWrapper = styled.div`
	display: flex;
	justify-content: center;
	margin: 0 auto;
	width: 180px;
	height: auto;
`;

export const LogoImage = styled.img`
	width: 100%;
	align-self: flex-start;
`;

export const InputWrapper = styled.div`
	width: 100%;
	margin-top: 3rem;
`;

export const Field = styled.div``;

export const CheckBoxWrapper = styled.div`
	margin-top: 1rem;

	span {
		color: #1e1e1e;
		font-weight: bold;
		margin: 0 0 0 1rem;
	}
`;

export const Label = styled.p`
	font-size: 20px;
	font-weight: bold;
	color: #064f91;
	margin: 20px 0 10px 0;
`;

export const LoginInput = styled(Input)`
	&& {
		width: 100%;
		border-radius: 3px;
		height: 50px;
		font-weight: bold;
		color: #1e1e1e;
		border-color: ${({ error }) => error && css`red`};
	}
`;

export const LoginButton = styled(SubmitButton).attrs(({ margin }) => ({
	btnMargin: margin ? margin : "4rem 0 0 0",
}))`
	margin: ${({ btnMargin }) => btnMargin};
	width: 100%;
	height: 58px;
`;

export const LabelWrapper = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	align-items: baseline;
`;

export const Link = styled.a.attrs(({ margin }) => ({
	margin: margin ? margin : 0,
}))`
	color: #1e1e1e;
	font-weight: bold;
	position: relative;
	width: fit-content;
	margin: ${({ margin }) => margin};
	display: block;

	&:hover,
	&:focus {
		&:after {
			background: transparent;
		}
	}

	&:after {
		content: "";
		width: 100%;
		height: 2px;
		background: #1e1e1e;
		position: absolute;
		bottom: -1px;
		left: 0;
		transition: background 0.2s ease-in-out;
	}
`;

export const ErrorText = styled.p`
	font-size: 14px;
	color: red;
	margin: 5px 0 0 0;
`;

export const LoginErrorText = styled(ErrorText)`
	font-size: 16px;
	margin: 1rem 0 0 0;
`;

export const ResetTextStyle = styled.p.attrs(({ success }) => ({
	success: success ? "green" : "black",
}))`
	color: ${({ success }) => success};
`;
